var socialMediaPopover = {
    props: ['visible', 'accounts', 'type', 'count'],
    computed: {
        ruleName() {
            return {
                title: '标题',
                keywords: '关键词',
                description: '描述'
            }[this.type];
        },
        titleEmpty() {
            return this.type === 'title' && !this.count;
        },
        validationList() {
            var valid = [], invalid = [];
            this.accounts.forEach((ac) => {
                if (
                    (ac.account.length && ac.isChecked)
                    || (ac.jujiao_account.length && ac.jujiao_isChecked && ac.jujiao_isShow)
                ) {
                    var rules = ac.rules;
                    var typeRule = rules && rules[this.type];
                    if (typeRule) {
                        var limit = typeRule.limit;
                        var obj = {
                            limit,
                            icon: ac.icon,
                            media: ac.media - 0
                        };
                        if (this.titleEmpty) {
                            invalid.push(obj);
                        } else if (!limit || limit >= this.count) {
                            valid.push(obj);
                        } else {
                            invalid.push(obj);
                        }
                    }
                }
            });

            return {
                valid,
                invalid,
                total: valid.length + invalid.length
            };
        }
    },
    render(h) {
        return h('el-popover', {
            attrs: {
                width: 400,
                trigger: 'hover',
                placement: 'right',
                popperClass: 'share_account_container social-media-popover'
            }
        }, [
            h('h4', {
                class: 'social-media-popover__title'
            }, [
                '社媒平台',
                h('small', {
                    class: 'social-media-popover__small social-media-popover__text'
                }, [
                    ' (',
                    this.validationList.valid.length,
                    '/',
                    this.validationList.total,
                    ')'
                ])
            ]),
            this.validationList.valid.length ? [
                h('p', {
                    class: 'social-media-popover__subtitle social-media-popover__text'
                }, [
                    this.ruleName,
                    '长度符合以下社媒平台规则:'
                ]),
                h('div', {
                    class: 'social-media-popover__list'
                }, this.validationList.valid.map((item, i) => h('div', {
                    class: 'social-media-popover__item',
                    key: i
                }, [
                    h('span', {
                        class: 'release_icon',
                        style: {
                            backgroundImage: `url(${item.icon})`,
                            backgroundSize: item.media == 3 ? '29px 20px' : '20px 20px'
                        }
                    }),
                    h('span', {
                        class: 'social-media-popover__text'
                    }, [
                        this.count, '/', item.limit || '∞'
                    ])
                ])))
            ] : [],
            this.validationList.invalid.length && !this.titleEmpty ? [
                h('p', {
                    class: 'social-media-popover__subtitle social-media-popover__text'
                }, this.validationList.valid.length ? [
                    '但不符合以下社媒平台规则，请修正:'
                ] : [
                    this.ruleName,
                    '长度不符合以下社媒平台规则，请修正:'
                ]),
                h('div', {
                    class: 'social-media-popover__list'
                }, this.validationList.invalid.map((item, i) => h('div', {
                    class: 'social-media-popover__item social-media-popover__item--invalid',
                    key: i
                }, [
                    h('span', {
                        class:'release_icon',
                        style: {
                            backgroundImage: `url(${item.icon})`,
                          backgroundSize: item.media == 3 ? '29px 20px' : '20px 20px'
                        }
                    }),
                    h('span', {
                        class: 'social-media-popover__text'
                    }, [
                        this.count, '/', item.limit || '∞'
                    ])
                ])))
            ] : [],
            this.titleEmpty? h('p', {
                    class: 'social-media-popover__subtitle social-media-popover__text'
                }, [
                    '请输入标题。'
                ])
                : this.validationList.total ? [] : h('p', {
                    class: 'social-media-popover__subtitle social-media-popover__text'
                }, [
                    '当前所选社媒平台无需填写',
                    this.ruleName,
                    '。'
                ]),
            h('span', {
                slot: 'reference',
                class: [
                    'el-input__icon social-media-validation-icon',
                    this.validationList.invalid.length
                        ? '' : 'el-icon-success'
                ]
            }, this.validationList.invalid.length ? [
                h('span', {
                    class: 'social-media-validation-icon__badge'
                }, [this.validationList.invalid.length])
            ] : [])
        ]);
    },
    mounted() {
        console.log(this.accounts);
    }
}
export default socialMediaPopover;
